import {
  React,
  Select,
  Switch,
  Button,
  toast,
  useState,
  Dialog,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  DatePicker,
  DatePanel,
  useUpdatePostSchedulingMutation,
  GetCookie,
} from "../../../../Libraries/Post/GetAllPostRelatedToScreen/ScreenWisePostScheduling/index";
// import '../styles.css'
import { useUpdateMediaSchedulingMutation, useUpdateschedullinggroupMutation } from "../../../../Redux/service/AllEmpData";
const options = [
  { label: "Monday", value: "Monday" },
  { label: "Tuesday", value: "Tuesday" },
  { label: "Wednesday", value: "Wednesday" },
  { label: "Thursday", value: "Thursday" },
  { label: "Friday", value: "Friday" },
  { label: "Saturday", value: "Saturday" },
  { label: "Sunday", value: "Sunday" },
];


const GroupWisePostScheduling = (props) => {
const [updateMediaSchedule] = useUpdateschedullinggroupMutation();

  const [data, setdata] = useState({
    ser_assoc_id: props?.schinfo?.ser_assoc_id,
    switchcontroller: props?.schinfo?.is_scheduled,
    is_Scuduled: props?.schinfo?.is_scheduled,
    daywiseordatewise:
      props?.schinfo?.date_wise_or_day_wise === "N/A"
        ? ""
        : props?.schinfo?.date_wise_or_day_wise,
    selecteddates:
      props?.schinfo?.date_wise_scheduled_dates === "N/A"
        ? []
        : props?.schinfo?.date_wise_scheduled_dates?.split(","),
    selecteddays: props?.schinfo?.days === "N/A" ? [] : props?.schinfo?.days,
    values:
      props?.schinfo?.date_wise_scheduled_dates === "N/A"
        ? []
        : props?.schinfo?.date_wise_scheduled_dates?.split(","),
  });

  const handleChangeIs_Scuduled = (e) => {
    setdata({
      ...data,
      is_Scuduled: e.target.checked,
    });
  };
  const handledatewiseofdayswise = (e) => {
    setdata({
      ...data,
      daywiseordatewise: e.target.value,
      selecteddays: [],
      selecteddates: [],
    });
  };
  const handleChangeSelectedDays = (e) => {
    setdata({
      ...data,
      selecteddays: e,
    });
  };
  const handleChangeSelectedDates = (e) => {
    const datesx = e.map((date) => date.format());
    setdata({
      ...data,
      values: datesx,
      selecteddates: datesx.toString(),
    });
  };

  const handleSubmitPostScheduling = async () => {
    const payload = new FormData();
    payload.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
    payload.append("security_token",await GetCookie("es_token"));
    // payload.append("ser_post_id", props.schinfo.ser_post_id);
    payload.append("ser_collection_id", props.screen);
    payload.append("ser_assoc_id", data.ser_assoc_id);
    // console.log("lat 3= ", props.screen);
    // console.log("lat 3= ", data.ser_assoc_id);

    if (data.is_Scuduled && data.daywiseordatewise === "Date wise") {
      payload.append("is_scheduled", data.is_Scuduled);
      payload.append("date_wise_or_day_wise", data.daywiseordatewise);
      payload.append("date_wise_scheduled_dates", data.selecteddates);
      payload.append("days", "N/A");
    } else if (data.is_Scuduled && data.daywiseordatewise === "Day wise") {
      const formatedscudlueddays = String(
        data.selecteddays?.map((day) => day.value)
      );
      payload.append("days", formatedscudlueddays);
      payload.append("is_scheduled", data.is_Scuduled);
      payload.append("date_wise_or_day_wise", data.daywiseordatewise);
      payload.append("date_wise_scheduled_dates", "N/A");
    } else if (!data.is_Scuduled) {
      payload.append("is_scheduled", data.is_Scuduled);
      payload.append("date_wise_or_day_wise", "N/A");
      payload.append("date_wise_scheduled_dates", "N/A");
      payload.append("days", "N/A");
    }

    if (data.is_Scuduled && data.daywiseordatewise === "") {
      toast.error("please select the scheduling scheme");
    } else if (
      data.is_Scuduled &&
      data.daywiseordatewise === "Day wise" &&
      (data.selecteddays === null ||
        data.selecteddays === "null" ||
        data.selecteddays === undefined ||
        data.selecteddays === "undefined" ||
        data.selecteddays.length === 0)
    ) {
      toast.error("please select at least one day");
    } else if (
      data.is_Scuduled &&
      data.daywiseordatewise === "Date wise" &&
      (data.selecteddates === null ||
        data.selecteddates === "null" ||
        data.selecteddates === undefined ||
        data.selecteddates === "undefined" ||
        data.selecteddates.length === 0)
    ) {
      toast.error("please select at least one date");
    } else {
      try {
        const response = await updateMediaSchedule(payload).unwrap();
        // console.log(response);
        if (
          response.status === "true" &&
          response.message === "Schedule updated successfully" &&
          response.connection === "true"
        ) {
          toast.success(response.message);
          props?.close();
          props?.getAllPosts(props?.defaultScreen);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        toast.error(error.status);
        console.log(error);
      }
    }
  };

  const addScreenWisePostSchedulingfooter = (
    <React.Fragment>
      <Button variant="contained" className="capitalized fs-14 fw-bold" onClick={handleSubmitPostScheduling}>
        {!data?.switchcontroller ? "Add" : "Update"}
      </Button>
    </React.Fragment>
  );

  // console.log(data)
  return (
    <>
      <Dialog
        visible={props?.show}
        style={{ width: "500px" }}
        breakpoints={{ "960px": "75vw", "640px": "100vw" }}
        header={"Screen-wise Scheduling"}
        modal
        footer={addScreenWisePostSchedulingfooter}
        onHide={props?.close}
      >
        <>
          <div className="row">
            <div className="col">
              <div className="form-group">
                <label htmlFor="formControlRange">Post Schedule</label>
                <Switch
                  checked={data?.is_Scuduled}
                  inputProps={{ "aria-label": "controlled" }}
                  onChange={handleChangeIs_Scuduled}
                />
              </div>
            </div>
          </div>
          {data?.is_Scuduled && (
            <>
              <div className="row">
                <div className="col">
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group"
                      name="demo-row-radio-buttons-group"
                      value={data?.daywiseordatewise}
                      onChange={handledatewiseofdayswise}
                    >
                      <FormControlLabel
                        value="Day wise"
                        control={<Radio />}
                        label="Day wise"
                      />
                      <FormControlLabel
                        value="Date wise"
                        control={<Radio />}
                        label="Date wise"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
              {data?.daywiseordatewise === "Day wise" ? (
                <div className="row">
                  <div className="col">
                    <div className="form-group">
                      <label htmlFor="formControlRange">Schedule Days</label>
                      <Select
                        options={options}
                        isMulti="true"
                        isClearable={true}
                        value={data?.selecteddays}
                        onChange={handleChangeSelectedDays}
                        name="scudleddays"
                        placeholder="Select Days"
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                          menuPortal: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                        }}
                      />
                    </div>
                  </div>
                </div>
              ) : data?.daywiseordatewise === "Date wise" ? (
                <div className="row">
                  <div className="col">
                    <DatePicker
                      multiple
                      sort
                      calendarPosition="bottom-center"
                      value={data?.values}
                      onChange={handleChangeSelectedDates}
                      plugins={[<DatePanel key={data?.values}/>]}
                    />
                  </div>
                </div>
              ) : null}
            </>
          )}
        </>
      </Dialog>
    </>
  );
};

export default GroupWisePostScheduling;
